import { AppPlanInfo, PlanPrivacy, PlanType, SubscriptionType } from "common/app-plans";
import { IconImage } from "common/components/SerializedApp";
import { Owner } from "common/Database";
import { CardPreview } from "common/firebase-function-types";
import { GlideFC } from "lib/glide-fc";
import { useMemo } from "react";
import { styled } from "sharedUI/styles";
import AppPlanConfirm from "./private/app-plan-confim";
import { CardLoading } from "./private/app-plan-loading";
import AppPlanPreview from "./private/app-plan-preview";

const AppPlanReviewContainer = styled.div`
    display: flex;
`;

interface Props {
    fromPanel: boolean;
    owner: Owner;
    appPlanInfo: AppPlanInfo;
    appName: string;
    appIcon: IconImage;
    appAccentColor: string;
    plan: PlanType;
    privacy: PlanPrivacy;
    subscription: SubscriptionType;
    numPrivateUsers: number;
    estimate: number | undefined;
    cardPreview: CardPreview | undefined;
    subscriptionChange: (subscription: SubscriptionType) => void;
    privateUsersChange: (numUsers: number) => void;
    goToBilling: () => void;
    onPromoCodeApplied: () => void;
}

// NOTE: This is used by both the billing settings confirmation as
// well as the upgrade modal
const AppPlanReview: GlideFC<Props> = p => {
    const {
        fromPanel,
        appPlanInfo,
        appName,
        plan,
        privacy,
        subscription,
        numPrivateUsers,
        appAccentColor,
        appIcon,
        estimate,
        privateUsersChange,
        subscriptionChange,
        goToBilling,
        cardPreview,
        owner,
        onPromoCodeApplied,
    } = p;

    const content = useMemo(() => {
        return cardPreview === undefined ? (
            <CardLoading />
        ) : (
            <AppPlanConfirm
                fromPanel={fromPanel}
                appPlanInfo={appPlanInfo}
                appName={appName}
                privacy={privacy}
                subscription={subscription}
                editBilling={goToBilling}
                cardPreview={cardPreview}
            />
        );
    }, [appName, appPlanInfo, cardPreview, fromPanel, goToBilling, privacy, subscription]);

    return (
        <AppPlanReviewContainer>
            <AppPlanPreview
                fromPanel={fromPanel}
                appPlanInfo={appPlanInfo}
                locked={true}
                plan={plan}
                privacy={privacy}
                subscription={subscription}
                numPrivateUsers={numPrivateUsers}
                appAccentColor={appAccentColor}
                appIcon={appIcon}
                estimate={estimate}
                privateUsersChange={privateUsersChange}
                subscriptionChange={subscriptionChange}
                onEditPrivateUsers={goToBilling}
                owner={owner}
                onPromoCodeApplied={onPromoCodeApplied}
            />
            {content}
        </AppPlanReviewContainer>
    );
};

export default AppPlanReview;
